<ng-container *ngFor="let modal of modals">
  <dcp-default-modal [modalId]="modal.id"></dcp-default-modal>
</ng-container>